const staticTexts = {
    //onboarding texts
    whatsappRemindersBenefits: [
        "Enabling whatsapp reminders makes sure that you never miss your bills.",
        "You can always disable communications via WhatsApp in future.",
    ],
    smsTncText: [
        "You hereby consent and agree that We will have access to messages received on your device including any financial information sent in a form of text or other message (“SMS”).",
        "You understand that the SMS is being viewed and collected on behalf of Zipcash Card Services Private Limited (“Zipcash”)). Zipcash may use, store or share with third parties, such information received on your device for the purpose of evaluating your profile to offer you additional services from time to time.",
        'In the event if you wish to delete any information collected by Zipcash, or withdraw consent to read/use/store/share SMS data, then you may write to us at <a href="mailto:care@zipcash.in">care@zipcash.in',
        'You will comply with terms and conditions made available at <a href="mailto:care@zipcash.in">care@zipcash.in'
    ],
    unRegisteredNumberMessage: "Number is not registered with OlaMoney. Kindly provide a different number or register yourself.",
    ppWhitelistedSheetHeader: "Upgrade to Postpaid+",
    ppNotAvailableSheetHeader: "Postpaid is currently unavailable",
    ppWhitelistedTileInfoItem: [
        'Login to your Ola app and upgrade to Postpaid+.',
        'You can still complete this transaction using other payment modes.'
    ],
    ppNotAvailableTileInfoItem: [
        'Postpaid is not applicable on this transaction, please visit Ola app for more details.',
        'You can still complete this transaction using other payment modes.'
    ]
};